import { ViewDensity, ViewType } from "@common/types/views/views";
import {
    Form1099NecColumn,
    Form1099NecView,
} from "@common/types/views/form1099NecView";
import { ViewConfig } from "@lib/views";
import { AMOUNT_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import { Form1099NecRow } from "./form1099NecFormat";
import {
    Form1099NecAccountCell,
    Form1099NecAmountCell,
    Form1099NecBalanceCell,
    Form1099NecBoxCell,
    Form1099NecDateCell,
    Form1099NecDescriptionCell,
    Form1099NecReferenceCell,
    Form1099NecSourceCell,
    Form1099NecSplitCell,
} from "./form1099NecCells";

const DATE_MIN_SIZE = 280;
const DATE_MAX_SIZE = 500;
const SOURCE_MIN_SIZE = 120;
const REFERENCE_MIN_SIZE = 120;
const DESCRIPTION_MIN_SIZE = 200;
const FORM_1099_BOX_MIN_SIZE = 160;
const ACCOUNT_MIN_SIZE = 180;
const SPLIT_MIN_SIZE = 140;
const DEFAULT_MAX_SIZE = 400;

export function buildForm1099NecConfig(): ViewConfig<
    Form1099NecRow,
    string,
    never
> {
    return {
        columns: {
            [Form1099NecColumn.DATE]: {
                name: "Vendor / Date",
                header: "Date",
                accessorKey: "rowKind",
                cell: Form1099NecDateCell,
                minSize: DATE_MIN_SIZE,
                maxSize: DATE_MAX_SIZE,
                immutable: true,
            },
            [Form1099NecColumn.SOURCE]: {
                name: "Source",
                header: "Source",
                accessorKey: "rowKind",
                cell: Form1099NecSourceCell,
                minSize: SOURCE_MIN_SIZE,
                maxSize: DEFAULT_MAX_SIZE,
            },
            [Form1099NecColumn.REFERENCE]: {
                name: "Reference",
                header: "Reference",
                accessorKey: "rowKind",
                cell: Form1099NecReferenceCell,
                minSize: REFERENCE_MIN_SIZE,
                maxSize: DEFAULT_MAX_SIZE,
            },
            [Form1099NecColumn.DESCRIPTION]: {
                name: "Description",
                header: "Description",
                accessorKey: "rowKind",
                cell: Form1099NecDescriptionCell,
                minSize: DESCRIPTION_MIN_SIZE,
                maxSize: DEFAULT_MAX_SIZE,
            },
            [Form1099NecColumn.FORM_1099_BOX]: {
                name: "1099 box",
                header: "1099 box",
                accessorKey: "rowKind",
                cell: Form1099NecBoxCell,
                minSize: FORM_1099_BOX_MIN_SIZE,
                maxSize: DEFAULT_MAX_SIZE,
            },
            [Form1099NecColumn.ACCOUNT]: {
                name: "Account",
                header: "Account",
                accessorKey: "rowKind",
                cell: Form1099NecAccountCell,
                minSize: ACCOUNT_MIN_SIZE,
                maxSize: DEFAULT_MAX_SIZE,
            },
            [Form1099NecColumn.SPLIT]: {
                name: "Split",
                header: "Split",
                accessorKey: "rowKind",
                cell: Form1099NecSplitCell,
                minSize: SPLIT_MIN_SIZE,
                maxSize: DEFAULT_MAX_SIZE,
            },
            [Form1099NecColumn.AMOUNT]: {
                name: "Amount",
                header: "Amount",
                accessorKey: "rowKind",
                cell: Form1099NecAmountCell,
                ...AMOUNT_COLUMN_SIZE,
                immutable: true,
            },
            [Form1099NecColumn.BALANCE]: {
                name: "Balance",
                header: "Balance",
                accessorKey: "rowKind",
                cell: Form1099NecBalanceCell,
                ...AMOUNT_COLUMN_SIZE,
                immutable: true,
            },
        },
        nesting: {
            enabled: true,
            expandColumn: Form1099NecColumn.DATE,
            childrenKey: "children",
        },
    };
}

export function buildForm1099NecView(): Form1099NecView {
    return {
        type: ViewType.FORM_1099_NEC,
        columns: [
            { id: Form1099NecColumn.DATE, options: { pin: "left" } },
            { id: Form1099NecColumn.SOURCE },
            { id: Form1099NecColumn.REFERENCE },
            { id: Form1099NecColumn.DESCRIPTION },
            { id: Form1099NecColumn.FORM_1099_BOX },
            { id: Form1099NecColumn.ACCOUNT },
            { id: Form1099NecColumn.SPLIT },
            { id: Form1099NecColumn.AMOUNT, options: { pin: "right" } },
            { id: Form1099NecColumn.BALANCE, options: { pin: "right" } },
        ],
        filters: {},
        options: {
            selection: false,
            bulkActions: false,
            density: ViewDensity.LG,
        },
    };
}
